import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={43}
    height={43}
    fill="none"
    style={{transform:(props.isLeft ? 'rotate(180deg)' : '')}}
    {...props}
  >
    <circle
      cx={21.5}
      cy={21.5}
      r={21}
      fill="#fff"
      fillOpacity={0.7}
      stroke={`url(#a${props.pathId})`}
    />
    <path stroke={`url(#b${props.pathId})`} d="m18 15 7.5 7-7 6.5" />
    <defs>
      <linearGradient
        id={"a"+props.pathId}
        x1={6.17}
        x2={41.662}
        y1={1.911}
        y2={41.27}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.154} stopColor="#3D1B00" />
        <stop offset={0.361} stopColor="#816A34" />
        <stop offset={0.798} />
      </linearGradient>
      <linearGradient
        id={"b"+props.pathId}
        x1={19.076}
        x2={29.082}
        y1={15.6}
        y2={21.764}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.154} stopColor="#3D1B00" />
        <stop offset={0.361} stopColor="#816A34" />
        <stop offset={0.798} />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
